import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { alpha, styled } from '../../utils';
import { Typography } from '../Typography';
export const HeroImage = memo(function HeroImage(props) {
    return (_jsx(RootStyled, { imgSrc: props.imgSrc, children: _jsx(OverlayStyled, { children: _jsx(TextStyled, { variant: "h2", children: props.children }) }) }));
});
const RootStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'imgSrc',
})(({ imgSrc }) => ({
    backgroundImage: `url(${imgSrc})`,
    backgroundPosition: 'left center',
    backgroundSize: 'cover',
    width: '100%',
    height: '300px',
}));
const OverlayStyled = styled('div')(({ theme }) => ({
    backgroundColor: alpha(theme.palette.secondary.dark, 0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
}));
const TextStyled = styled(Typography)(({ theme }) => ({
    padding: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.h3.fontSize,
    },
}));
